import Layout from '@/layout';

export default {
  path: '/raman-query-list',
  component: Layout,
  meta: {
    title: '拉曼数据管理',
    code: '0108',
    icon: 'el-icon-search'
  },
  children: [
    {
      path: '',
      name: 'raman-add',
      component: () => import('@/views/ramanQueryList'),
      meta: {
        title: '新增化验项',
        code: '0108'
      }
    },
    {
      path: 'query',
      name: 'raman-query',
      component: () => import('@/views/ramanQueryList/query.vue'),
      meta: {
        title: '查询化验结果',
        code: '0108'
      }
    }
  ]
};
